import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";
import "@/assets/custom.css";

Vue.use(Vuetify, {
  iconfont: "md",
  options: {
    minifyTheme: function(css) {
      return process.env.NODE_ENV === "production"
        ? css.replace(/[\s|\r\n|\r|\n]/g, "")
        : css;
    }
  }
});



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js